<template>
  <DashboardHero :loading="loading">
    <template v-slot:title>Exp. Insurance:</template>
    <template v-slot:value>
      <el-popover
        placement="top-start"
        title="Exp. Insurances"
        width="200"
        trigger="hover"
        content="Expiring / Expired"
      >
        <div slot="reference" style="display: inline !important">
          {{ expiringCount }} / {{ expiredCount }}
        </div>
      </el-popover>
    </template>
  </DashboardHero>
</template>

<script>
import axios from 'axios';
import DashboardHero from './DashboardHero';
import { RISKS_API_BASE } from '../env';

export default {
  name: 'FacilityExpInsurance',
  props: {
    facility: { type: String, required: true },
  },
  components: { DashboardHero },
  watch: {
    async facility() {
      this.loading = true;
      await this.getFacilityOccupancy();
      this.loading = false;
    },
  },
  async mounted() {
    if (!this.facility) {
      return;
    }

    await this.getFacilityOccupancy();
    this.loading = false;
  },
  data() {
    return {
      loading: true,
      expiringCount: 0,
      expiredCount: 0,
    };
  },
  methods: {
    async getFacilityOccupancy() {
      try {
        const endpoint = this.facility ? `/insurance/${this.facility}` : '/insurance';
        const response = await axios.get(`${RISKS_API_BASE}/v2${endpoint}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });

        this.expiringCount = response.data.expiringCount;
        this.expiredCount = response.data.expiredCount;
      } catch (err) {
        this.$message({
          message: 'Failed to fetch Exp. insurances',
        });
      }
    },
  },
};
</script>

<style scoped>
.wallet-text {
  color: #efefef;
  font-weight: 300;
}

.wallet-head {
  font-weight: 400;
  margin: 0;
  color: #009aca;
}
</style>



// WEBPACK FOOTER //
// src/components/FacilityExpInsurance.vue